const BASE_URL = import.meta.env.VITE_BACKEND_URL

export { BASE_URL }